import React, { useState } from 'react'
import { Dropdown } from 'react-bootstrap'
import { updateSorting } from './AccountAuditSlice';
import { useAppDispatch, useAppSelector } from '../../app/hooks';
import { Link } from 'react-router-dom';
import { KTIcon } from '../../_metronic/helpers';
import { ShowSwalWithConfirmation } from '../../common/SweetAlert';
import CustomPagination from "../../common/Pagination";
import { ShowToast } from '../../common/Toastr';
import moment from "moment";
import { FormatInvoiceDecimalNumber, formatCurrntDateTime, formatDateWithDateAndMonthName, formatDateWithTime, getValueFromResource, getAndSetCustomFieldValues, formatDateWithTZ } from '../../common/timeLiveFunction';
import clsx from "clsx";
const itemClass = 'ms-1 ms-lg-0';

const AccountAuditItem = (props: any) => {
    const { customFieldsArrayP, accountAuditList, t} = props;
    const dispatch = useAppDispatch();
    const { isLoading, sortOrder, sortColumn, pageSize } = useAppSelector((state) => state.audit);
    const { decimalPlaces, cultureInfoName } = useAppSelector((state) => state.globalState);
    const onHandleClientSideSorting = (sortOrder: string, sortColumn: string) => {
        dispatch(updateSorting({
            "sortOrder": sortOrder,
            "sortColumn": sortColumn,
            "pageSize": pageSize,
            "pageNo": 1
        }));
    }

    const setCustomFieldValues = (databaseFieldName: string, value: any) => {
        if (value === null || value === undefined || value === '' || value === 'NaN' || String(value).toLowerCase() === 'nan') {
            return '';
        }const field = customFieldsArrayP.find(
            (item: any) => item.DatabaseFieldName === databaseFieldName
        );
        if (!field) {
            return value;
        }
        switch (field.MasterCustomDataTypeName) {
            case 'Number':
                const numValue = parseFloat(value);
                if (isNaN(numValue)) {
                    return '';
                }
                return FormatInvoiceDecimalNumber(
                    cultureInfoName.toString(),
                    numValue,
                    decimalPlaces
                );
            case 'Date':
                return formatDateWithDateAndMonthName(
                    value,
                    cultureInfoName.toString()
                );
            default:
                return value;
        }
    };

    const convertToISO = (dateString: string) => {
        const dateConvert = moment(dateString, 'MMM D YYYY h:mmA').utc().toISOString();
        return formatCurrntDateTime(dateConvert, cultureInfoName.toString());
    };

const detectValueType = (value: any) => {
    console.log(value,"value")
    if (!value || value === '') return 'TEXT';
    
    const strValue = String(value).trim();
        if (strValue === 'true' || strValue === 'false') {
        return 'BOOLEAN';
    }
   
    const datetimePattern = /\d{4}-\d{2}-\d{2}[T\s]\d{2}:\d{2}/;
    if (datetimePattern.test(strValue)) {
        return 'DATETIME';
    }
    
    const datePattern = /^\d{4}-\d{2}-\d{2}$/;
    if (datePattern.test(strValue)) {
        return 'DATE';
    }
    
    if (!isNaN(parseFloat(value)) && isFinite(value) && 
        !/[a-zA-Z]/.test(strValue) && 
        strValue !== '0' && strValue !== '1') {
        return 'NUMERIC';
    }
    
    return 'TEXT';
};

const formatAuditValue = (value: any, cultureInfoName: any, decimalPlaces: any, fieldName: any) => {

    const name = fieldName ? fieldName.toString() : '';

    if (name.endsWith('Id') || name.endsWith('ID')) {
        return value;
    }

    let valueType = detectValueType(value);

    if (name.startsWith('Is')) {
        valueType = 'BOOLEAN';
    }

    if (name.includes('Amount')) {
        valueType = 'NUMERIC';
    }

    if (name.includes('Date')) {
        if (/\d{4}-\d{2}-\d{2}/.test(String(value))) {
            valueType = 'DATE';
        } else {
            valueType = 'TEXT';
        }
    }

    switch(valueType) {
        case 'BOOLEAN':
            // Checks for 1, true, True to return "Yes", otherwise "No"
            const strVal = String(value).toLowerCase();
            return (strVal === '1' || strVal === 'true')
                ? getValueFromResource('Yes', dispatch, t) 
                : getValueFromResource('No', dispatch, t);
        
        case 'DATETIME':
            return formatCurrntDateTime(value, cultureInfoName.toString());
        
        case 'DATE':
            return formatDateWithDateAndMonthName(value, cultureInfoName.toString());
        
        case 'NUMERIC':
            return FormatInvoiceDecimalNumber(cultureInfoName.toString(), value, decimalPlaces);
        
        case 'TEXT':
            return fieldName === 'Hired Date' ? convertToISO(value) : value;
        default:
            return getValueFromResource(value, dispatch, t);
    }
};

    return (
        <>
             <table className='table table-row-bordered table-bottom-color align-middle gs-1 gy-1 gx-1' >
                <thead>
                    <tr className="thHeading align-middle " >
                    <th style={{ width: '15%' }}>
                        {/* {t('Updated Date')} */}
                        {getValueFromResource('Updated Date',dispatch, t)}
                        {sortColumn === 'UpdatedOn' ?
                                sortOrder === 'asc' ? <span className="headerSortIconBG cursor" onClick={() => { onHandleClientSideSorting("desc", "UpdatedOn") }}>
                                    <i className="ki-outline ki-arrow-up sortIconColor fs-5 sortMT"></i>
                                </span> : <span className="headerSortIconBG cursor" onClick={() => { onHandleClientSideSorting("asc", "UpdatedOn") }}>
                                    <i className="ki-outline ki-arrow-down sortIconColor fs-5 sortMT"></i>
                                </span>
                                :
                                // hoveredColumn === 0 &&
                                <><span className="cursor" onClick={() => { onHandleClientSideSorting("asc", "UpdatedOn") }}>
                                    <i className="bi bi-sort-up fs-6 headerSortIcon">
                                        <span className="path1"></span>
                                        <span className="path2"></span>
                                    </i>
                                </span>
                                    <span className="cursor" onClick={() => { onHandleClientSideSorting("desc", "UpdatedOn") }}>
                                        <i className="bi bi-sort-down fs-6 headerSortIcon">
                                            <span className="path1"></span>
                                            <span className="path2"></span>
                                        </i>
                                    </span>
                                </>}
                        </th>
                        <th style={{ width: '15%' }}>
                            {/* {t('Field Name')} */}
                            {getValueFromResource('Field Name',dispatch, t)}
                        {sortColumn === 'FieldName' ?
                                sortOrder === 'asc' ? <span className="headerSortIconBG cursor" onClick={() => { onHandleClientSideSorting("desc", "FieldName") }}>
                                    <i className="ki-outline ki-arrow-up sortIconColor fs-5 sortMT"></i>
                                </span> : <span className="headerSortIconBG cursor" onClick={() => { onHandleClientSideSorting("asc", "FieldName") }}>
                                    <i className="ki-outline ki-arrow-down sortIconColor fs-5 sortMT"></i>
                                </span>
                                :
                                // hoveredColumn === 0 &&
                                <><span className="cursor" onClick={() => { onHandleClientSideSorting("asc", "FieldName") }}>
                                    <i className="bi bi-sort-up fs-6 headerSortIcon">
                                        <span className="path1"></span>
                                        <span className="path2"></span>
                                    </i>
                                </span>
                                    <span className="cursor" onClick={() => { onHandleClientSideSorting("desc", "FieldName") }}>
                                        <i className="bi bi-sort-down fs-6 headerSortIcon">
                                            <span className="path1"></span>
                                            <span className="path2"></span>
                                        </i>
                                    </span>
                                </>}
                        </th>
                        <th style={{ width: '15%' }}>
                            {/* {t('New Value')} */}
                            {getValueFromResource('Old Value',dispatch, t)}
                        {sortColumn === 'OldValue' ?
                                sortOrder === 'asc' ? <span className="headerSortIconBG cursor" onClick={() => { onHandleClientSideSorting("desc", "OldValue") }}>
                                    <i className="ki-outline ki-arrow-up sortIconColor fs-5 sortMT"></i>
                                </span> : <span className="headerSortIconBG cursor" onClick={() => { onHandleClientSideSorting("asc", "OldValue") }}>
                                    <i className="ki-outline ki-arrow-down sortIconColor fs-5 sortMT"></i>
                                </span>
                                :
                                // hoveredColumn === 0 &&
                                <><span className="cursor" onClick={() => { onHandleClientSideSorting("asc", "OldValue") }}>
                                    <i className="bi bi-sort-up fs-6 headerSortIcon">
                                        <span className="path1"></span>
                                        <span className="path2"></span>
                                    </i>
                                </span>
                                    <span className="cursor" onClick={() => { onHandleClientSideSorting("desc", "OldValue") }}>
                                        <i className="bi bi-sort-down fs-6 headerSortIcon">
                                            <span className="path1"></span>
                                            <span className="path2"></span>
                                        </i>
                                    </span>
                                </>}
                        </th>
                        <th style={{ width: '15%' }}>
                            {/* {t('New Value')} */}
                            {getValueFromResource('New Value',dispatch, t)}
                        {sortColumn === 'NewValue' ?
                                sortOrder === 'asc' ? <span className="headerSortIconBG cursor" onClick={() => { onHandleClientSideSorting("desc", "NewValue") }}>
                                    <i className="ki-outline ki-arrow-up sortIconColor fs-5 sortMT"></i>
                                </span> : <span className="headerSortIconBG cursor" onClick={() => { onHandleClientSideSorting("asc", "NewValue") }}>
                                    <i className="ki-outline ki-arrow-down sortIconColor fs-5 sortMT"></i>
                                </span>
                                :
                                // hoveredColumn === 0 &&
                                <><span className="cursor" onClick={() => { onHandleClientSideSorting("asc", "NewValue") }}>
                                    <i className="bi bi-sort-up fs-6 headerSortIcon">
                                        <span className="path1"></span>
                                        <span className="path2"></span>
                                    </i>
                                </span>
                                    <span className="cursor" onClick={() => { onHandleClientSideSorting("desc", "NewValue") }}>
                                        <i className="bi bi-sort-down fs-6 headerSortIcon">
                                            <span className="path1"></span>
                                            <span className="path2"></span>
                                        </i>
                                    </span>
                                </>}
                        </th>
                        <th style={{ width: '15%' }}>
                            {/* {t('Update By')} */}
                            {getValueFromResource('Update By',dispatch, t)}
                        {sortColumn === 'UpdateBy' ?
                                sortOrder === 'asc' ? <span className="headerSortIconBG cursor" onClick={() => { onHandleClientSideSorting("desc", "UpdateBy") }}>
                                    <i className="ki-outline ki-arrow-up sortIconColor fs-5 sortMT"></i>
                                </span> : <span className="headerSortIconBG cursor" onClick={() => { onHandleClientSideSorting("asc", "UpdateBy") }}>
                                    <i className="ki-outline ki-arrow-down sortIconColor fs-5 sortMT"></i>
                                </span>
                                :
                                // hoveredColumn === 0 &&
                                <><span className="cursor" onClick={() => { onHandleClientSideSorting("asc", "UpdateBy") }}>
                                    <i className="bi bi-sort-up fs-6 headerSortIcon">
                                        <span className="path1"></span>
                                        <span className="path2"></span>
                                    </i>
                                </span>
                                    <span className="cursor" onClick={() => { onHandleClientSideSorting("desc", "UpdateBy") }}>
                                        <i className="bi bi-sort-down fs-6 headerSortIcon">
                                            <span className="path1"></span>
                                            <span className="path2"></span>
                                        </i>
                                    </span>
                                </>}</th>                        
                    </tr>
                </thead>
                <tbody>
                    {accountAuditList.length > 0 && accountAuditList.map((auditList: any, i: any) => (
                        <tr key={i}  style={{ height:42 }}>
                            <td>
                            {/* {moment(auditList.UpdatedOn).format('DD MMM yy - h:mm A')} */}
                            {/* {formatDateWithTime(auditList.UpdatedOn, cultureInfoName.toString())} */}
                             {formatCurrntDateTime(auditList.UpdatedOn, cultureInfoName.toString())}                            
                            </td>
                            <td>
                            {auditList.FieldName}
                            </td>
                            <td>
                                {/* {auditList.OldValue} */}
                                {auditList.FieldName.startsWith('Custom Field') ?
                                            getAndSetCustomFieldValues(auditList.FieldName.replace(/\s/g, ''), auditList.OldValue, customFieldsArrayP, cultureInfoName.toString(), decimalPlaces) :
                                            formatAuditValue(
                                    auditList.OldValue,
                                    cultureInfoName,
                                    decimalPlaces,
                                    auditList.FieldName)}
{/*                                 {formatAuditValue(
                                    auditList.OldValue,
                                    cultureInfoName,
                                    decimalPlaces,
                                    auditList.FieldName
                                )} */}

                            </td>
                            <td>
                                {/* {auditList.NewValue} */}
                                    {auditList.FieldName.startsWith('Custom Field') ?
                                            getAndSetCustomFieldValues(auditList.FieldName.replace(/\s/g, ''), auditList.NewValue, customFieldsArrayP, cultureInfoName.toString(), decimalPlaces) :
                                            formatAuditValue(
                                    auditList.NewValue,
                                    cultureInfoName,
                                    decimalPlaces,
                                    auditList.FieldName)}
{/*                                 {formatAuditValue(
                                    auditList.NewValue,
                                    cultureInfoName,
                                    decimalPlaces,
                                    auditList.FieldName
                                )} */}

                            </td> 
                            <td>
                            {auditList.UpdateBy}
                            </td>         
                        </tr>
                    ))}
                </tbody>
            </table>
            {accountAuditList.length === 0 &&
                            <div className=''>
                                <p className='noDataFound'>
                                    {/* {t('No Record Found')} */}
                                    {getValueFromResource('No Record Found',dispatch, t)}
                                    </p>
                            </div>
                        }
        </>
    )

}

export default AccountAuditItem